import { useEffect } from 'react';

import { IntegrationBaseForm } from '@form/integration-base/integration-base.form';
import { useGetConnectionQuery } from '@hook/connection/connection.hooks';
import { ConnectorInterface } from '@interface/connector/connector.interface';
import { BaseFormInterface } from '@interface/form/base-form.interface';
import { ErrorFormInterface } from '@interface/form/error-form.interface';
import { isExist } from '@util/data/is-exist';

import { getIntegrationFields } from './integration-base.fields-map';

interface IntegrationBaseProps extends BaseFormInterface {
  connector: ConnectorInterface;
  onEnable: (enabled: boolean) => void;
}

export const IntegrationBase = ({ form, connector, onEnable }: IntegrationBaseProps) => {
  const { data, error } = useGetConnectionQuery(connector, { refetchOnMountOrArgChange: true, refetchOnFocus: true });

  useEffect(() => void (isExist(data) && form.setFieldsValue(data.data)), [data]);

  return (
    <IntegrationBaseForm
      error={error as ErrorFormInterface}
      fields={getIntegrationFields(connector.serviceId)}
      form={form}
      onEnable={onEnable}
    />
  );
};
